import ReactQuill from "react-quill";
import { CreateTermsApi } from "../../../services/apis/EventMangement/CreateEventApi";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import BtnLoader from "../Loader/BtnLoader";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const TermsAndCompliance = ({ eventId }) => {
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [formData, setFormData] = useState({
    terms_and_conditions: "",
    moderation: "",
  });

  const [errors, setErrors] = useState({
    terms_and_conditions: "",
    moderation: "",
  });

  const handleChange = (field, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData?.terms_and_conditions?.trim()) {
      newErrors.terms_and_conditions = "Terms and Conditions is required.";
    }

    if (!formData?.moderation?.trim()) {
      newErrors.moderation = "Content Moderation is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      console.log("Validation errors:", errors);
      return;
    }
    setBtnLoading(true);
    try {
      const response = await CreateTermsApi(eventId, formData);
         console.log("resss",response)
      if (response?.data?.success) {
        toast.success(response?.data?.message, {
          position: "top-center",
        });
        setFormData({
         terms_and_conditions: "",
         moderation: "",
        });
        Swal.fire({
           icon: "success",
           title: "Event",
           text: response?.data?.message,
        });
        navigate("/all-events")
      }
    } catch (error) {
      console.error("Error while submitting the form:", error);
      toast.error(error?.response?.data?.error, {
        position: "top-center",
      });
    }finally{
      setBtnLoading(false);
    }
  };

  const handleTermsAndConditionsChange=(value)=>{
    const text = value?.replace(/<[^>]*>?/gm, "");
    if (text?.length <= 500) {
      setFormData((prevState) => ({
        ...prevState,
        terms_and_conditions: value,
      }));
      setErrors({
        ...errors,
        terms_and_conditions: "",
      });
    } else {
      setErrors({
        ...errors,
        terms_and_conditions: "Terms And Conditions cannot exceed 500 characters.",
      });
    } 
  }

  const handleContentChange = (value) => {
    const text = value?.replace(/<[^>]*>?/gm, "");
    if (text?.length <= 500) {
      setFormData((prevState) => ({
        ...prevState,
        moderation: value,
      }));
      setErrors({
        ...errors,
        moderation: "",
      });
    } else {
      setErrors({
        ...errors,
        moderation: "Content Moderation cannot exceed 500 characters.",
      });
    }
  };

  return (
    <>
     <ToastContainer />
      <div className="container-fluid my-0">
        <div className="row col-12">
          <div className="col-12">
            <form onSubmit={handleSubmit}>
              {/* Terms and Conditions Section */}
              <div className="card profile-card card-bx">
                <div className="card-header">
                  <h6 className="card-title">Terms and Conditions</h6>
                </div>
                <div className="card-body">
                  <div className="mb-3 row">
                    <div className="col-sm-12">
                      <label className="col-sm-3 col-form-label">
                        About<span className="asterisk">*</span>
                      </label>

                      <ReactQuill
                        value={formData?.terms_and_conditions}
                        onChange={handleTermsAndConditionsChange}
                        placeholder="Ex: House#94  Road#8  Abc City"
                      />
                       {errors.terms_and_conditions && <small className="text-danger">{errors.terms_and_conditions}</small>}
                  
                    </div>

                    {/* <div className="col-sm-12 mt-3">
                            <label className="col-12 col-form-label">
                                <input type="checkbox" className="me-2" />
                                I confirm that all the information provided is accurate and agree to the platform's event posting guidelines.
                            </label>
                        </div> */}
                  </div>
                </div>
              </div>

              {/* Content Moderation Section */}
              <div className="card profile-card card-bx">
                <div className="card-header">
                  <h6 className="card-title">Content Moderation</h6>
                </div>
                <div className="card-body">
                  <div className="mb-3 row">
                    <div className="col-sm-12">
                      <label className="col-sm-3 col-form-label">
                        About<span className="asterisk">*</span>
                      </label>

                      <ReactQuill
                        value={formData?.moderation}
                        onChange={handleContentChange}
                        placeholder="Ex: House#94  Road#8  Abc City"
                      />
                      {errors.moderation && <small className="text-danger">{errors.moderation}</small>}
                     
                    </div>

                    {/* <div className="col-sm-12 mt-3">
                        <label className="col-12 col-form-label">
                            <input type="checkbox" className="me-2" />
                            I understand that the platform reserves the right to review and approve the event details before listing.
                        </label>
                    </div> */}
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-primary">
                 {btnLoading && <BtnLoader/>}  Save and Continue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndCompliance;
